import script from "./dropzone-file.vue?vue&type=script&setup=true&lang=js"
export * from "./dropzone-file.vue?vue&type=script&setup=true&lang=js"

import "./dropzone-file.vue?vue&type=style&index=0&id=e14dcd02&lang=scss"

const __exports__ = script;

export default __exports__